const searchSelectors = {
  filterParent: document.getElementById('searchFilters'),
  gridsContainer: document.getElementById('search-product-grid'),
  openDrawerBtns: document.querySelectorAll('[data-openFilterDrawer]'),
  closeDrawer: document.querySelector('#searchFilters .collection-filters-close')
};

class TemplateSearchJS {
  constructor() {
    const sortInputs = document.querySelectorAll('[data-sortby] [name="sort_by"]');
    if (!sortInputs.length) return;

    sortInputs.forEach((input) => {
      input.addEventListener('change', () => {
        const selectedRadio = document.querySelector('[data-sortby] [name="sort_by"]:checked');
        if (!selectedRadio) return;
        window.location.href = Utility.replaceUrlParam(window.location.href, 'sort_by', selectedRadio.value);
      });
    });
  }
}

class SearchFilters {
  constructor() {
    if (!searchSelectors.filterParent || !searchSelectors.gridsContainer) return;

    this.filterForm = searchSelectors.filterParent.querySelector('#SearchFiltersForm');
    this.filterCounter = document.querySelector('.filter-counter');
    this.onSubmitHandler = this.onSubmitHandler.bind(this);
    this.toggleFilterDrawer = this.toggleFilterDrawer.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.updateSortBy = this.updateSortBy.bind(this);
    this.managePagination = this.managePagination.bind(this);
    this.onApplyFilters = this.onApplyFilters.bind(this);

    this.debouncedOnSubmit = Utility.debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    if (this.filterForm) {
      // Event delegation on the form so listeners survive AJAX re-renders
      this.filterForm.addEventListener('input', (event) => {
        if (event.target.type === 'range') return;
        // Mobile: wait for Apply button while drawer is open
        if (window.innerWidth < 992 || searchSelectors.filterParent.classList.contains('filter-active')) {
          return;
        }
        this.debouncedOnSubmit(event);
      });
      this.filterForm.addEventListener('submit', this.debouncedOnSubmit);
    }

    this.bindEvents();
    this.dynamicEleEvents();
    this.handleHideShowDrawerToggle();
    this.updateFilterCounter();
  }

  handleHideShowDrawerToggle() {
    const toggleButton = document.querySelector('[data-hideshowfilterdrawer]');
    const filtersParent = searchSelectors.filterParent;

    if (!toggleButton || !filtersParent) return;

    this.syncFilterSidebarLayout();

    if (toggleButton._filterToggleHandler) {
      toggleButton.removeEventListener('click', toggleButton._filterToggleHandler);
    }

    toggleButton._filterToggleHandler = (event) => {
      if (event && typeof event.preventDefault === 'function') event.preventDefault();

      // `#searchFilters.open` is the hidden/collapsed state (same as collection).
      const sidebarCurrentlyHidden = filtersParent.classList.contains('open');
      const sidebarShouldBeHidden = !sidebarCurrentlyHidden;

      filtersParent.classList.toggle('open', sidebarShouldBeHidden);
      filtersParent.classList.toggle('close', !sidebarShouldBeHidden);

      this.syncFilterSidebarLayout();
    };

    toggleButton.addEventListener('click', toggleButton._filterToggleHandler);
  }

  syncFilterSidebarLayout() {
    const filtersParent = searchSelectors.filterParent;
    const toggleButton = document.querySelector('[data-hideshowfilterdrawer]');
    const gridsContainer = searchSelectors.gridsContainer;
    const productGrids = gridsContainer?.querySelector('#template-search.product-grid-main, .product-grid-main');

    if (!filtersParent || !gridsContainer) return;

    const sidebarVisible = filtersParent.classList.contains('close');

    if (sidebarVisible) {
      gridsContainer.classList.remove('sidebar-product-grid-open');
      if (productGrids) productGrids.classList.remove('product-grid-arent');
      if (toggleButton) {
        toggleButton.classList.remove('open');
        toggleButton.classList.add('close');
      }
    } else {
      gridsContainer.classList.add('sidebar-product-grid-open');
      if (productGrids) productGrids.classList.add('product-grid-arent');
      if (toggleButton) {
        toggleButton.classList.remove('close');
        toggleButton.classList.add('open');
      }
    }
  }

  bindEvents() {
    searchSelectors.openDrawerBtns.forEach((button) => {
      button.addEventListener('click', this.toggleFilterDrawer);
    });

    document.addEventListener('mouseup', this.handleClickOutside);

    if (searchSelectors.closeDrawer) {
      searchSelectors.closeDrawer.addEventListener('click', this.toggleFilterDrawer);
    }

    searchSelectors.filterParent.addEventListener('keyup', (event) => {
      if (event.code?.toUpperCase() === 'ESCAPE' && searchSelectors.closeDrawer) {
        searchSelectors.closeDrawer.dispatchEvent(new Event('click'));
      }
    });

    document.querySelectorAll('[data-sortByDesktop] .sortby_options, [data-sortby] .sortby_options').forEach((input) => {
      input.addEventListener('change', this.updateSortBy);
    });
  }

  handleClickOutside(event) {
    if (!document.body.classList.contains('filter-drawer-opened')) return;
    if (event.target === searchSelectors.filterParent || searchSelectors.filterParent.contains(event.target)) return;

    this.closeFilterDrawer();
  }

  dynamicEleEvents() {
    const applyBtn = searchSelectors.filterParent.querySelector('[data-applyFilters]');
    if (applyBtn) {
      applyBtn.removeEventListener('click', this.onApplyFilters);
      applyBtn.addEventListener('click', this.onApplyFilters);
    }

    this.bindActiveFilterButtonEvents();

    document.querySelectorAll('#search-product-grid [data-pagelinks]').forEach((link) => {
      link.removeEventListener('click', this.managePagination);
      link.addEventListener('click', this.managePagination);
    });
  }

  onApplyFilters(event) {
    event.preventDefault();
    if (!this.filterForm) return;

    const searchParams = this.createQueryString(this.filterForm);
    this.renderPage(searchParams);

    setTimeout(() => {
      this.closeFilterDrawer();
    }, 300);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    if (!this.filterForm) return;

    searchSelectors.filterParent.classList.add('loading');
    const searchParams = this.createQueryString(this.filterForm);
    this.renderPage(searchParams);
  }

  createQueryString(form) {
    const formData = new FormData(form);
    const priceGteInput = form.querySelector('[name="filter.v.price.gte"]');
    const priceLteInput = form.querySelector('[name="filter.v.price.lte"]');

    if (priceGteInput) {
      if (parseInt(formData.get('filter.v.price.gte'), 10) === parseInt(priceGteInput.min || 0, 10)) {
        formData.delete('filter.v.price.gte');
      }
    }
    if (priceLteInput) {
      if (parseInt(formData.get('filter.v.price.lte'), 10) === parseInt(priceLteInput.max || priceLteInput.placeholder, 10)) {
        formData.delete('filter.v.price.lte');
      }
    }

    return new URLSearchParams(
      Array.from(formData).filter(([, value]) => value !== null && value !== undefined && value !== '')
    ).toString();
  }

  renderPage(searchParams, updateURLHash = true) {
    searchSelectors.gridsContainer.classList.add('loading');
    const url = `${window.location.pathname}?${searchParams}`;
    this.renderGridFromFetch(url);
    window.scrollTo({ top: 0, behavior: 'smooth' });
    if (updateURLHash) this.updateURLHash(searchParams);
  }

  renderGridFromFetch(url) {
    if (!url) return;

    const sectionID = searchSelectors.gridsContainer.dataset.id;
    const separator = url.includes('?') ? '&' : '?';

    fetch(`${url}${separator}sections=${sectionID}`)
      .then((response) => response.json())
      .then((response) => {
        this.renderProductGrid(response[sectionID]);
      })
      .catch(() => {
        searchSelectors.filterParent.classList.remove('loading');
        searchSelectors.gridsContainer.classList.remove('loading');
      });
  }

  renderProductGrid(grid) {
    if (!grid) return;

    const openFilterIndexes = Array.from(
      searchSelectors.filterParent.querySelectorAll('.filter__container.open, .collapsible_panel.open')
    ).map((el) => el.dataset.index);

    const searchParent = new DOMParser().parseFromString(grid, 'text/html');

    const gridsEl = searchParent.getElementById('search-product-grid');
    if (gridsEl) {
      searchSelectors.gridsContainer.innerHTML = gridsEl.innerHTML;
    }

    // Update filter blocks in place (same pattern as collection filters)
    // so form listeners and collapsible state stay intact
    const incomingPanels = searchParent.querySelectorAll('#SearchFiltersForm .filter__container');
    const existingPanels = this.filterForm
      ? this.filterForm.querySelectorAll('.filter__container')
      : [];

    existingPanels.forEach((panel) => panel.classList.add('d-none'));

    incomingPanels.forEach((panel) => {
      const filterBlock = this.filterForm?.querySelector(`.filter__container[data-index="${panel.dataset.index}"]`);
      if (!filterBlock) return;

      const incomingBlock = panel.querySelector('.filter__block');
      const existingBlock = filterBlock.querySelector('.filter__block');
      if (incomingBlock && existingBlock) {
        existingBlock.innerHTML = incomingBlock.innerHTML;
      }

      const incomingLabel = panel.querySelector('.panel_toggle span');
      const existingLabel = filterBlock.querySelector('.panel_toggle span');
      if (incomingLabel && existingLabel) {
        existingLabel.textContent = incomingLabel.textContent;
      }

      filterBlock.classList.remove('d-none');
    });

    // Sync hidden fields (q, type, sort_by)
    ['q', 'type', 'sort_by'].forEach((name) => {
      const incoming = searchParent.querySelector(`#SearchFiltersForm [name="${name}"]`);
      const existing = this.filterForm?.querySelector(`[name="${name}"]`);
      if (incoming && existing) existing.value = incoming.value;
    });

    // Footer buttons (mobile)
    const incomingFooter = searchParent.querySelector('#SearchFiltersForm .sidebar-filter-footer');
    const existingFooter = this.filterForm?.querySelector('.sidebar-filter-footer');
    if (incomingFooter && existingFooter) {
      existingFooter.innerHTML = incomingFooter.innerHTML;
    }

    // Active filters chips
    const activeFilters = searchParent.querySelector('[data-activefilters]');
    let activeFiltersTarget = document.querySelector('[data-activefilters]');
    if (activeFilters) {
      if (activeFiltersTarget) {
        activeFiltersTarget.innerHTML = activeFilters.innerHTML;
      } else {
        const sidebar = searchSelectors.filterParent;
        const insertBefore = sidebar.querySelector('#main-search-filters') || sidebar.firstElementChild;
        activeFiltersTarget = activeFilters.cloneNode(true);
        sidebar.insertBefore(activeFiltersTarget, insertBefore);
      }
    } else if (activeFiltersTarget) {
      activeFiltersTarget.innerHTML = '';
    }

    const productCount = searchParent.querySelector('[data-productCount]');
    const productCountTarget = document.querySelector('[data-productCount]');
    if (productCount && productCountTarget) {
      productCountTarget.innerHTML = productCount.innerHTML;
    }

    // Restore previously open filter panels
    openFilterIndexes.forEach((index) => {
      const filterBlock = this.filterForm?.querySelector(`.filter__container[data-index="${index}"]`);
      if (!filterBlock) return;
      filterBlock.classList.add('open');
      const content = filterBlock.querySelector('.filter__block');
      if (content) {
        content.classList.add('open');
        content.style.height = 'auto';
      }
    });

    searchSelectors.closeDrawer = document.querySelector('#searchFilters .collection-filters-close');
    if (searchSelectors.closeDrawer) {
      searchSelectors.closeDrawer.removeEventListener('click', this.toggleFilterDrawer);
      searchSelectors.closeDrawer.addEventListener('click', this.toggleFilterDrawer);
    }

    this.updateFilterCounter();
    searchSelectors.filterParent.classList.remove('loading');
    searchSelectors.gridsContainer.classList.remove('loading');
    this.dynamicEleEvents();
    this.syncFilterSidebarLayout();
  }

  updateFilterCounter() {
    if (!this.filterCounter || !searchSelectors.filterParent) return;

    this.filterCount = searchSelectors.filterParent.querySelectorAll(
      '.sidebar-filter input[type="checkbox"]:checked'
    ).length;
    this.filterCounter.innerText = this.filterCount;

    if (this.filterCount > 0) {
      this.filterCounter.classList.remove('d-none');
    } else {
      this.filterCounter.classList.add('d-none');
    }
  }

  bindActiveFilterButtonEvents() {
    document.querySelectorAll('.filter-option-clear').forEach((element) => {
      element.removeEventListener('click', this.onActiveFilterClick);
      element.addEventListener('click', this.onActiveFilterClick);
    });
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    event.stopImmediatePropagation();

    const urlString = new URL(event.currentTarget.href).searchParams.toString();
    this.renderPage(urlString || '');
  }

  updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams ? `?${searchParams}` : ''}`);
  }

  updateSortBy(event) {
    const value = event.currentTarget.value;
    const targetOpt = this.filterForm?.querySelector(`input[name="sort_by"][value="${value}"]`);

    if (targetOpt) {
      targetOpt.value = value;
      const searchParams = this.createQueryString(this.filterForm);
      // Ensure sort_by is present
      const params = new URLSearchParams(searchParams);
      params.set('sort_by', value);
      this.renderPage(params.toString());
    } else {
      window.location.href = Utility.replaceUrlParam(window.location.href, 'sort_by', value);
    }
  }

  managePagination(event) {
    event.preventDefault();
    const nextPageLink = event.currentTarget.href;
    this.renderGridFromFetch(nextPageLink);
    setTimeout(() => {
      history.pushState({}, '', nextPageLink);
    }, 500);
  }

  closeFilterDrawer() {
    searchSelectors.filterParent.classList.remove('filter-active');
    if (this.openFilterDrawer) {
      this.openFilterDrawer.setAttribute('aria-expanded', false);
      this.openFilterDrawer.removeAttribute('tabindex');
    }
    Utility.removeTrapFocus(searchSelectors.filterParent);
    siteOverlay.prototype.hideOverlay();
    document.body.classList.remove('filter-drawer-opened');
  }

  toggleFilterDrawer(event) {
    event.preventDefault();
    const button = event.currentTarget;

    if (button.id === 'filter-drawer') {
      this.openFilterDrawer = button;
      button.setAttribute('aria-expanded', true);
      button.setAttribute('tabindex', '-1');
      searchSelectors.filterParent.classList.add('filter-active');
      Utility.trapFocus(searchSelectors.filterParent);
      if (searchSelectors.closeDrawer) Utility.forceFocus(searchSelectors.closeDrawer);
      siteOverlay.prototype.showOverlay();
      document.body.classList.add('filter-drawer-opened');
    } else {
      this.closeFilterDrawer();
    }
  }
}

typeof TemplateSearchJS !== 'undefined' && new TemplateSearchJS();
typeof SearchFilters !== 'undefined' && new SearchFilters();
